import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiGrid, FiClock, FiLayers, FiSettings, FiHexagon, FiZap, FiInfo } from 'react-icons/fi';

const navItems = [
  { path: '/', icon: FiGrid, label: 'Cockpit' },
  { path: '/timer', icon: FiClock, label: 'Focus Timer' },
  { path: '/cards', icon: FiLayers, label: 'Flashcards' },
  { path: '/demo', icon: FiZap, label: 'Demo' },
  { path: '/settings', icon: FiSettings, label: 'Settings' },
];

const Sidebar = () => {
  return (
    <>
      <aside className="hidden md:flex flex-col w-64 h-screen border-r border-[#2a2d4f] bg-[#0d0f21] glass-panel fixed left-0 top-0 pt-6 pb-6 z-50">
        <div className="flex items-center px-6 mb-12">
          <SafeIcon icon={FiHexagon} className="text-[#eaff00] text-3xl mr-3 glow-yellow-text" />
          <h1 className="text-xl font-bold tracking-wider">StudyHalo</h1>
        </div>

        <nav className="flex-1 px-4 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center px-4 py-3 rounded-xl transition-all duration-300 ${
                  isActive
                    ? 'bg-[#eaff00]/10 text-[#eaff00] border border-[#eaff00]/30 glow-yellow'
                    : 'text-slate-400 hover:text-slate-100 hover:bg-[#15172b]'
                }`
              }
            >
              <SafeIcon icon={item.icon} className="mr-4 text-lg" />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="px-6 mt-auto">
          <div className="p-4 bg-[#15172b] rounded-2xl border border-[#2a2d4f] mb-6">
            <p className="text-[10px] text-slate-500 uppercase tracking-widest mb-1">System Status</p>
            <div className="flex items-center text-xs text-[#eaff00]">
              <div className="w-1.5 h-1.5 bg-[#eaff00] rounded-full mr-2 animate-pulse"></div>
              All Nodes Active
            </div>
          </div>
          <div className="text-[10px] text-slate-500 text-center opacity-50 hover:opacity-100 transition-opacity">
            Made by <a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer">DigLab.ai</a> and <a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer">LingLinkAI.cn</a>
          </div>
        </div>
      </aside>

      <nav className="md:hidden fixed bottom-0 left-0 right-0 glass-panel border-t border-[#2a2d4f] z-50 pb-safe">
        <div className="flex justify-around items-center p-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center p-2 rounded-lg transition-colors ${
                  isActive ? 'text-[#eaff00]' : 'text-slate-400'
                }`
              }
            >
              <SafeIcon icon={item.icon} className="text-xl mb-1" />
              <span className="text-[10px]">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
};

export default Sidebar;